import { codeSplit } from 'bernie-core';

export const FigureMap = codeSplit(
  () => import(/* webpackChunkName: "figure-component" */ '../figure') as any
);
